import Button from '$store/components/ui/Button.tsx'
import Icon from '$store/components/ui/Icon.tsx'
import { sendEvent } from '$store/sdk/analytics.ts'
import { useUI } from '$store/sdk/useUI.ts'
import { AnalyticsItem } from 'apps/commerce/types.ts'

interface Props {
    loading: boolean
    currency: string
    total: number
    items: AnalyticsItem[]
    isMinicart?: boolean
    size?: 'md' | 'lg'
}

function CartButton({ loading, currency, total, isMinicart, items, size = 'md' }: Props) {
    const { displayCart, displayMenu } = useUI()
    const totalItems = items.length
    const iconSize = size === 'lg' ? 27 : 20

    const onClick = () => {
        sendEvent({
            name: 'view_cart',
            params: { currency, value: total, items },
        })
        displayCart.value = true
        displayMenu.value = false
    }

    return (
        <div class='indicator'>
            <Button
                class='h-fit relative md:justify-center md:items-center md:gap-3 flex px-0 py-0 gap-2 text-start font-normal'
                data-deco={displayCart.value && 'open-cart'}
                loading={loading}
                onClick={onClick}
            >
                <span class='sr-only'>abre o carrinho</span>
                <Icon
                    id='Bag'
                    height={iconSize}
                    width={iconSize}
                    strokeWidth={2}
                    class={`${
                        isMinicart
                            ? 'text-primary-700 hover:text-primary-500'
                            : 'text-neutral-1 hover:text-primary-700'
                    }`}
                />
                <span class='bg-primary-700 absolute -right-[15px] top-[1px] text-white text-xs w-5 h-5 rounded-full flex items-center justify-center'>
                    <span>{totalItems}</span>
                </span>
            </Button>
        </div>
    )
}

export default CartButton
